export default {"src":"/_next/static/media/abitab.7ff9ccf9.svg","height":17,"width":62,"blurWidth":0,"blurHeight":0};